module.exports = __webpack_public_path__ + "img/heart-outline.1197566f.svg";